import styled from "styled-components";
import { Card } from "react-bootstrap";

export const ProductContainer = styled.div`
  padding-top: 0;
  max-width: var(--container);
  margin-inline: auto;
`;

export const ProductHeader = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  align-items: baseline;
  justify-content: space-between;
  padding: clamp(1.5rem, 5vw, 3rem) var(--gutter) 0;
`;

export const Text = styled.p`
  margin: 0;
  font-size: var(--step-0);
  color: var(--ink-soft);
`;

export const TextBold = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: var(--step-0);
  color: var(--ink);
`;

/* Responsive product grid: 2-up on phones → up to 4-up on desktop */
export const ProductWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: clamp(0.9rem, 3.5vw, 2rem) clamp(0.6rem, 2vw, 1.25rem);
  padding: clamp(1.25rem, 4vw, 2.5rem) var(--gutter);

  @media (min-width: 640px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const ProductCard = styled(Card)`
  width: 100%;
  height: auto;
  border: none;
  background: transparent;
  cursor: pointer;

  .card-body {
    padding: 0.85rem 0.15rem 0;
  }
`;

/* Image frame — fixed 3:4 ratio, no more letterboxing */
export const ProductImageWrapper = styled.div`
  position: relative;
  aspect-ratio: 3 / 4;
  background-color: var(--surface-2);
  border-radius: var(--radius-md);
  overflow: hidden;

  .icon-wrapper {
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(6px);
    border-radius: var(--radius-pill);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--ink);
    opacity: 0;
    transform: translateY(6px);
    transition: opacity var(--dur) var(--ease), transform var(--dur) var(--ease);
  }
  .icon-wrapper svg {
    color: var(--ink) !important;
  }

  &:hover .icon-wrapper {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ProductImage = styled(Card.Img)`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  padding: 0;
  /* cards fill their frame edge-to-edge (small crops are fine on thumbnails;
     the product page and quick view show the full uncropped photo) */
  object-fit: cover;
  border-radius: var(--radius-md);
  transition: transform 0.6s var(--ease);

  ${ProductImageWrapper}:hover & {
    transform: scale(1.04);
  }
`;

export const ProductName = styled(Card.Title)`
  font-size: var(--step-0);
  font-weight: 500;
  margin: 0.15rem 0;
  color: var(--ink);
`;

export const ProductDescription = styled(Card.Text)`
  font-size: var(--step--1);
  margin: 0.25rem 0;
  color: var(--muted);
`;

export const ProductPrice = styled(Card.Text)`
  font-size: var(--step-0);
  margin: 0.15rem 0;
  font-weight: 500;
  color: var(--ink);
`;

export const ProductDetails = styled(Card.Body)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;

export const ProductImagesOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity var(--dur) ease;
  background-color: rgba(0, 0, 0, 0.5);

  img {
    width: 50%;
    margin: 5px;
    object-fit: cover;
  }

  ${ProductImageWrapper}:hover & {
    opacity: 1;
  }
`;
